import React, { useState, useRef, useEffect } from "react";
import { Box, Button, Typography, TextField, Avatar } from "@mui/material";
import PhoneIcon from "../../assets/otp_logo.png";
import backgroundImg from "../../assets/login_bg.png";
import gift_logo from "../../assets/gift_logo.png";
import deleteSoundFile from "../../assets/keyboard.mp3"; // sound file
import { useLocation } from "react-router-dom";

export default function OtpVerification({
  handleSubmitOtp,
  setFinalOtp,
  setShowOtp,
  resendCode,


  setIsOTPScreen

}) {
  const [otp, setOtp] = useState([null, null, null, null]);
  const inputsRef = useRef([]);
  const deleteSound = useRef(new Audio(deleteSoundFile));

  const [timeLeft, setTimeLeft] = useState(30);
  const [canResend, setCanResend] = useState(false);
    const location = useLocation()
   /*  const navigate=useNavigate() */
    const params = new URLSearchParams(location.search);
const url = params.get("route");

let   tagOrderId = null;

if (url && url.includes("value=")) {
    tagOrderId = url.split("value=")[1];
}

  // OTP change
  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  // OTP backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputsRef.current[index - 1]?.focus();
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  const handleFocus = (index) => {
    inputsRef.current[index].select();
  };

  const handleBack = () => setShowOtp(false);

  const handleVerify = () => {
    const code = otp.join("");
    setFinalOtp && setFinalOtp(code);
    handleSubmitOtp(code);
  };

  // Countdown timer
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  const handleResend = () => {
    setTimeLeft(30);
    setCanResend(false);
    resendCode();
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2
      }}
    >
      <Box
        sx={{
          maxWidth: 400,
          width: "100%",
          borderRadius: 2,
          p: 4,
          pt: 2,
          textAlign: "center",
          bgcolor: { xs: "transparent", sm: "white" },
          boxShadow: { xs: "none", sm: 3 }
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          {/* Icon */}
          <Avatar
            src={tagOrderId ? gift_logo : PhoneIcon}
            sx={{
              width: tagOrderId ? 230 : 100,
              height: tagOrderId ? 230 : 100,
              mb: tagOrderId ? 0 : 3
            }}
          />

          {/* Title */}
          <Typography variant="h6" fontWeight="bold">
            Phone Verification
          </Typography>
          <Typography variant="body2" mb={1}>
            Enter the 4-digit code sent to your number.
          </Typography>

          {/* OTP Inputs */}
          <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
            {otp.map((digit, index) => (
              <TextField
                key={index}
                value={digit || ""}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onFocus={() => handleFocus(index)}
                inputRef={(el) => (inputsRef.current[index] = el)}
                variant="standard"
                inputProps={{
                  type: "tel",
                  inputMode: "numeric",
                  maxLength: 1,
                  style: {
                    textAlign: "center",
                    fontSize: "24px",
                    width: "50px",
                    height: "50px",
                    borderRadius: "8px",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid black"
                  }
                }}
                sx={{
                  "& .MuiInput-underline:before": { borderBottom: "none" },
                  "& .MuiInput-underline:after": { borderBottom: "none" },
                  "& .MuiInputBase-input": { padding: 0 }
                }}
              />
            ))}
          </Box>

          {/* Resend Timer */}
          <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
            Didn’t receive code?{" "}
            {canResend ? (
              <Button
                onClick={handleResend}
                sx={{ color: "green", padding: 0, height: "28px", lineHeight: 1.2 }}
              >
                Resend
              </Button>
            ) : (
              <Box component="span" sx={{ lineHeight: "28px", ml: 1 }}>
                Resend in {timeLeft}s
              </Box>
            )}
          </Typography>

          {/* Change Phone Number */}
          <Typography
            variant="body2"
            mb={3}
            mt={3}
            sx={{ textDecoration: "underline", cursor: "pointer", color: "primary.main" }}
            onClick={(e)=>{setIsOTPScreen(false)}}
          >
            Tap here to change phone number
          </Typography>

          {/* Verify Button */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleVerify}
            disabled={otp.join("").length !== 4}
            sx={{
              bgcolor: otp.join("").length === 4 ? "green" : "grey",
              color: "white",
              fontWeight: "bold",
              mb: 2,
              p: 2,
              "&:hover": { bgcolor: otp.join("").length === 4 ? "darkgreen" : "grey" }
            }}
          >
            VERIFY
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
